import React from 'react';

import {SmallLoader} from '@kit';

import {getApolloError} from '../../../../components/utils';
import {Markdown} from '../../../../components/utils/md';
import {useItemQuery} from '../../../../generated/types';
import {RuleExcerpts} from '../../../../components/rule-excerpts';

import css from './sheet.module.css';

type Props = {
	itemId: string;
};

/** описание предмета в раскрытой строке: те же разделы, что на странице предмета, включая пояснения свойств оружия */
export const ItemDescription: React.FC<Props> = ({itemId}) => {
	const {data, loading, error} = useItemQuery({variables: {id: itemId}});
	if (loading) return <SmallLoader />;
	if (error) return <div className={css.muted}>{getApolloError(error).message}</div>;
	const item = data?.item;
	if (!item) return null;
	const baseItem = item.baseItem || item.parentItem?.baseItem;
	const ruleExcerpts = item.ruleExcerpts ?? [];
	if (!item.parentItem?.description && !item.description && !baseItem?.description && !ruleExcerpts.length) {
		return <div className={css.muted}>Описания нет.</div>;
	}
	return (
		<div className={css.rowDescription}>
			{item.parentItem?.description && (
				<>
					<h3>{item.parentItem.title}</h3>
					<Markdown text={item.parentItem.description} payload={{genericChildren: true}} />
				</>
			)}
			{item.description && <Markdown text={item.description} />}
			{baseItem?.description && (
				<>
					<h3>{baseItem.title}</h3>
					<Markdown text={baseItem.description} />
				</>
			)}
			<RuleExcerpts excerpts={ruleExcerpts} />
			{item.mountMonster && (
				<Markdown
					text={`*_Параметры скакуна:_* Этот скакун есть в списке {@monster ${item.mountMonster.id}, чудовищ}`}
				/>
			)}
		</div>
	);
};
